import styled from "@emotion/styled";
import anime from 'animejs';
import Image from 'gatsby-image';
import TransitionLink from 'gatsby-plugin-transition-link';
// import Link from 'gatsby-link';
import React from "react";
import { H2, H5 } from '../grid/typography.component';

const exitAnimationDuration = 800;
const enterAnimationDelay = 500;
const enterAnimationDuration = 200;

class StudiesCard extends React.Component {

  constructor() {
    super()

    this.heroImage = React.createRef();
  }

  shouldComponentUpdate() {

    const { transitionStatus, entry, exit } = this.props;

    return transitionStatus.indexOf('exit') < 0;
  }
  exitAnimation({ node, e, exit, entry }) {
    // console.log(exit);
    // console.log(entry);

    const target = this.heroImage.current;
    const targetBounds = target.getBoundingClientRect();
    target.classList.add('zoom');
    anime({
      targets: target,
      top: [`${Math.round(targetBounds.top)}px`, 0],
      left: [`${Math.round(targetBounds.left)}px`, 0],
      width: [targetBounds.width, window.innerWidth],
      height: [targetBounds.height, window.innerHeight],
      duration: exitAnimationDuration,
      easing: 'easeOutQuart'
    })
  }
  render() {
    const { product, title, mainimage, card_image, uid, card_size, transitionStatus } = this.props;
    console.log('--- Render Study Card', transitionStatus);

    return (
      <Study>
        <TransitionLink
          to={`/${product.uid}`}
          exit={{
            length: exitAnimationDuration / 1000,
            // zIndex: 2,
            trigger: ({ node, e, exit, entry }) => this.exitAnimation({ node, e, exit, entry })
            // here node refers to the DOM node of the exiting page
          }}
          entry={{
            length: enterAnimationDuration / 1000,
            // zIndex: 0,
            // trigger: ({ node, e, exit, entry }) => console.log(node, e, exit, entry),
            delay: enterAnimationDelay / 1000,
          }}
        >
          <ImageWrapper className="image-wrapper" ref={this.heroImage}>
            <Image fluid={product.data.image.localFile.childImageSharp.fluid} />
          </ImageWrapper>
          <TextWrapper>
            <H2>The Kinuta project</H2>
            <H5>by {product.data.by.document.map(company => (<span key={company.data.name}>{company.data.name}</span>))}</H5>
          </TextWrapper>
        </TransitionLink>
      </Study>
    )
  }
}

export default StudiesCard


const CardHeight = '33vw';


const ImageWrapper = styled.div`
  overflow: hidden;
  /* height: 100%; */
  .tl-wrapper-status--exiting &{
    
  }
  .gatsby-image-wrapper{
    height: 100%;
  }
`

const TextWrapper = styled.div`

  position: absolute;
  bottom: -160px;
  width: 100%;
  h2, h5{
    transition: transform 1000ms,  opacity 200ms;
  }

  .tl-wrapper-status--exiting .zoom &{
      h2, h5{
        transform: translateY(50px);
        opacity: 0;
      }
    }
`


const Study = styled.div`
  min-width: 70vw;
  padding: 30px;
  display: flex;
  align-items: center;
  /* justify-content: center; */

  a{
    display: block;
    position: relative;
    width: 100%;
    height: 100%;

      text-decoration: none;
    *{
      pointer-events: none;
    }
    
    .gatsby-image-wrapper{
      transition: transform 1000ms;
      transform: scale(1);
    }
    
    
    &:hover{
      .gatsby-image-wrapper{
        transform: scale(1.05);
      }

      h2, h5{
        /* transform: translateY(10px); */
      }
    }

  }
  
  .image-wrapper{
    overflow: hidden;
  }
  .image-wrapper.zoom{
      position: fixed;
      z-index: 2000;
      .gatsby-image-wrapper{
        height: 100%;
        transition: transform ${exitAnimationDuration}ms;
        transform: scale(1);
      }
    }
`